module.exports = __webpack_public_path__ + "img/hourglass.5e588285.svg";